<template src="./Clinic.html" />

<script>
import { useStore } from "@/store/store.js"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import mixins from "../../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  props: ["idClinic"],
  mixins: [mixins],
  components: { WholeMultiselect },
  data: () => ({
    
      validValueMin: [{ value: false }],
      clinic: [],
      screenWidth: 0,
      showListClinics: false,
      mainClinic: "",
      specialties: [],
      assistantAdd: [],
      specialtiesAdd: [
        {
          valueMin: "",
          initial: "",
          end: "",
          specialty: {},
          checkedPresential: false,
          valuePresentialDisabled: true,
          checkedVideo: false,
          valueVideoDisabled: true,
          valueMinPresential: null,
          valueMinVideo: null
        }
      ],
      weekDaysSelected: [],
      notSchedule: false,
      options: [
        { text: "Seg", value: "MONDAY"},
        { text: "Ter", value: "TUESDAY"},
        { text: "Quar", value: "WEDNESDAY"},
        { text: "Qui", value: "THURSDAY"},
        { text: "Sex", value: "FRIDAY"},
        { text: "Sáb", value: "SATURDAY"},
        { text: "Dom", value: "SUNDAY"},
      ],
      optionsOne: [
        { text: "Seg", value: "MONDAY"},
        { text: "Ter", value: "TUESDAY"},
        { text: "Quar", value: "WEDNESDAY"},
        { text: "Qui", value: "THURSDAY"}
      ],
      optionsTwo: [
        { text: "Sex", value: "FRIDAY"},
        { text: "Sáb", value: "SATURDAY"},
        { text: "Dom", value: "SUNDAY"}
      ],
      address: {
        zipcode: "",
        city: "",
        complement: "",
        neighborhood: "",
        number: "",
        state: "",
        street: ""
      },
      phone: "",
      isCollapseOpen: true,
      showAssistants: true,
      specialtyGambiPresencial: [],
      specialtyGambiVideo: [],
      gambiPrice: [],
      test: [99],
      updateLayout: true,

  }),
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.addAssistant();
      vm.removeAssistant();
      vm.getSpecialties();
      vm.screenWidth = screen.width;
      if (vm.$props.idClinic !== null) {
        vm.getClinic();
      }
    },
    async getAddress() {
      const response = await this.getAddressByZipcode(this.address.zipcode)

      if (response && response.address) {
        this.address = response.address
      }
    },
    addSpecialty() {
      const vm = this;
      vm.specialtiesAdd.push([]);
    },
    postNewClinic() {
      const vm = this;
      let attendancesFinal = [];

      for (let i = 0; i < vm.specialtiesAdd.length; i++) {
        if (vm.specialtiesAdd[i].specialty !== undefined) {
          attendancesFinal.push({
            days: vm.weekDaysSelected[i] == null ? [] : vm.weekDaysSelected[i],
            end: vm.specialtiesAdd[i].end,
            initial: vm.specialtiesAdd[i].initial,
            price: parseFloat(vm.gambiPrice[i].replace(",", ".")),
            attendanceType:
              vm.specialtyGambiPresencial[i] === true ? 1 : 2,
            ignoreMatch:
              vm.specialtiesAdd[i].notSchedule == undefined
                ? false
                : vm.specialtiesAdd[i].notSchedule,
            specialty: vm.specialtiesAdd[i].specialty
          });
        }
      }
      
      if(vm.assistantAdd.length === 0){
        vm.addAssistant();
      }

      let clinic = {
        webClinic: {
          name: vm.mainClinic,
          phone: vm.phone,
          address: vm.address,
          assistants: vm.assistantAdd
        },
        attendances: attendancesFinal
      };

      vm.axios
        .post(vm.$store.state.filooServer + "doctor/clinic-doctors/", clinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 201) {
            vm.$swal({
              title: "Sucesso!",
              text: "Dados salvos com sucesso",
              icon: "success"
            }).then(function() {
              vm.backToListClinics();
            });
          }
        })
        .catch(function() {
          vm.$swal({
              title: "Atenção!",
              text: "Não foi possível realizar esta operação. Por favor entre em contato com o administrador do sistema.",
              icon: "error"
            });
        });
    },
    clickNotSchedule(index) {
      const vm = this;
      vm.specialtiesAdd[index].valueMin = null;
      vm.specialtiesAdd[index].initial = null;
      vm.specialtiesAdd[index].end = null;
      vm.weekDaysSelected[index] = null;
    },
    addAssistant() {
      const vm = this;
      vm.assistantAdd.push({});
      vm.showAssistants = false;
      setTimeout(function () {
        vm.showAssistants = true;
        vm.isCollapseOpen = true;
      }, 100);

    },
    removeSpecialty(index) {
      const vm = this;
      vm.specialtiesAdd.splice(index, 1);
      vm.specialtyGambiPresencial.splice(index, 1);
      vm.specialtyGambiVideo.splice(index, 1);
      vm.gambiPrice.splice(index, 1);
    },
    removeAssistant(index) {
      const vm = this;
      vm.assistantAdd.splice(index, 1);
    },
    backToListClinics() {
      sessionStorage.setItem("save_order", true);
      location.reload();
    },
    getSpecialties() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "doctor/specialties", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        });
    },
    validateFields(clinicType) {
      const vm = this;
      let validFields = true;
      let incorretMinValues = false;
      let personalAddressFields = false;
      
      if(vm.testNullUndefinedEmpty(vm.mainClinic)){
          validFields = false;
          personalAddressFields = true;
      }
      if(vm.testNullUndefinedEmpty(vm.phone)){
          validFields = false;
          personalAddressFields = true;
      }
      if(vm.testNullUndefinedEmpty(vm.address.zipcode) ||
        vm.testNullUndefinedEmpty(vm.address.city) ||
        vm.testNullUndefinedEmpty(vm.address.street) ||
        vm.testNullUndefinedEmpty(vm.address.state) ||
        vm.testNullUndefinedEmpty(vm.address.number) ){
          validFields = false;
          personalAddressFields = true;
      }

      for (let s in vm.specialtiesAdd) {
        if(vm.testNullUndefinedEmpty(vm.specialtiesAdd[s].initial) || 
        vm.testNullUndefinedEmpty(vm.specialtiesAdd[s].end)){
           validFields = false;
            vm.$vs.notify({
            title: "Atenção",
            time: 3500,
            position: "top-right",
            text:
              "Revise a(s) especialidade(s). Os horários inicial e final de atendimento são campos obrigatórios.",
            color: "warning"
          });
        }
        if (
          vm.specialtyGambiPresencial[s] === undefined || vm.testNullUndefinedEmpty(vm.gambiPrice[s])
        ) {
          vm.$vs.notify({
            title: "Atenção",
            time: 3500,
            position: "top-right",
            text:
              "Revise a(s) especialidade(s). O tipo de atendimento e o valor são campos obrigatórios.",
            color: "warning"
          });
          validFields = false;
        }

        if(vm.testNullUndefinedEmpty(vm.gambiPrice[s])){
          incorretMinValues = true;
          validFields = false;
        } else {
          let valueMin = vm.gambiPrice[s].replace(",", ".");
          if(valueMin < 10){
            incorretMinValues = true;
            validFields = false;
          }
        }
      }

      if (incorretMinValues === true) {
        vm.$vs.notify({
          title: "Atenção",
          time: 3500,
          position: "top-right",
          text:
            "Revise a(s) especialidade(s) adicionada(s). O valor mínimo permitido é R$10,00",
          color: "warning"
        });
      }
      if (personalAddressFields === true) {
        vm.$vs.notify({
          title: "Atenção",
          time: 3500,
          position: "top-right",
          text:
            "O nome da clínica, telefone e os dados de endereço são obrigatórios.",
          color: "warning"
        });
      }
      if (validFields === true) {
        if (clinicType == "oldClinic") {
          vm.putClinic();
        } else if (clinicType == "newClinic") {
          vm.postNewClinic();
        }
      }
    },
    putClinic() {
      const vm = this;
      let attendancesFinal = [];

      for (let i = 0; i < vm.specialtiesAdd.length; i++) {
        if (vm.specialtiesAdd[i].specialty !== undefined) {
          attendancesFinal.push({
            id: vm.specialtiesAdd[i].id,
            days: vm.weekDaysSelected[i] == null ? [] : vm.weekDaysSelected[i],
            end: vm.specialtiesAdd[i].end,
            initial: vm.specialtiesAdd[i].initial,
            price: parseFloat(vm.gambiPrice[i].replace(",", ".")),
            webClinicDoctor: null,
            showPrice: false,
            webClinicId: vm.clinic.webClinic.id,
            attendanceType:
              vm.specialtyGambiPresencial[i] === true ? 1 : 2,
            ignoreMatch:
              vm.specialtiesAdd[i].notSchedule == undefined
                ? false
                : vm.specialtiesAdd[i].notSchedule,
            specialty: vm.specialtiesAdd[i].specialty
          });
        }
      }

      let clinic = {
        id: vm.$props.idClinic,
        webClinic: {
          id: vm.clinic.webClinic.id,
          cnpj: vm.clinic.webClinic.cnpj,
          name: vm.mainClinic,
          socialName: vm.clinic.webClinic.socialName,
          legalRepresentative: vm.clinic.webClinic.legalRepresentative,
          phone: vm.phone,
          contactEmail: vm.clinic.webClinic.contactEmail,
          partner: vm.clinic.webClinic.partner,
          address: vm.address,
          assistants: vm.assistantAdd,
          active: vm.clinic.webClinic.active,
          countDoctors: vm.clinic.webClinic.countDoctors
        },
        doctor: vm.clinic.doctor,
        accept: vm.clinic.accept,
        mainAttendance: vm.clinic.mainAttendance,
        attendances: attendancesFinal
      };

      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/clinic-doctors/" +
            vm.$props.idClinic,
          clinic,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Dados salvos com sucesso",
              icon: "success"
            }).then(function() {
              vm.backToListClinics();
            });
          }
        })
        .catch(function() {
          vm.$swal({
              title: "Atenção!",
              text: "Não foi possível realizar esta operação. Por favor entre em contato com o administrador do sistema.",
              icon: "error"
            });
        });
    },
    getClinic() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/clinic-doctors/" +
            vm.$props.idClinic,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.clinic = response.data;
            vm.mainClinic = response.data.webClinic.name;
            vm.address = response.data.webClinic.address;
            vm.phone = response.data.webClinic.phone;
            vm.fillSpecialties(
              response.data.doctor.specialties,
              response.data.attendances
            );
            vm.fillAssistants(response.data.webClinic.assistants);
          }
        });
    },
    checkedPresential(index) {
      const vm = this;
      vm.specialtiesAdd[index].checkedPresential = !vm.specialtiesAdd[index].checkedPresential;
      if(vm.specialtiesAdd[index].checkedPresential === true){
        vm.specialtiesAdd[index].checkedVideo = false;
      }
      vm.specialtiesAdd[index].valueMin = null;
    },
    checkedVideo(index) {
      const vm = this;
      vm.specialtiesAdd[index].checkedVideo = !vm.specialtiesAdd[index].checkedVideo;
      if(vm.specialtiesAdd[index].checkedVideo === true){
        vm.specialtiesAdd[index].checkedPresential = false;
      }
      vm.specialtiesAdd[index].valueMin = null;
    },
    fillAssistants(assistants) {
      const vm = this;

      for (let i = 0; i < assistants.length; i++) {
        vm.assistantAdd[i] = assistants[i];
      }
    },
    fillSpecialties(specialties, attendances) {
      const vm = this;
      vm.specialties = specialties;
      for (let a in attendances) {
        vm.specialtiesAdd[a] = attendances[a];
        vm.specialtiesAdd[a].specialty = attendances[a].specialty;
        vm.specialtiesAdd[a].attendanceType = attendances[a].attendanceType;

        vm.specialties[a] = attendances[a].specialty;
        
        if (vm.specialties[a].id === attendances[a].specialty.id) {
          if(vm.testNullUndefinedEmpty(vm.specialtiesAdd[a].attendanceType) === false){
            if (vm.specialtiesAdd[a].attendanceType === 1) {
              vm.specialtiesAdd[a].checkedPresential = true;
              vm.specialtiesAdd[a].checkedVideo = false;

            }
            if (vm.specialtiesAdd[a].attendanceType === 2) {
              vm.specialtiesAdd[a].checkedPresential = false;
              vm.specialtiesAdd[a].checkedVideo = true;
            }
          }
        vm.specialtyGambiPresencial.push(vm.specialtiesAdd[a].checkedPresential)
        vm.specialtyGambiVideo.push(vm.specialtiesAdd[a].checkedVideo)

        if (vm.testNullUndefinedEmpty(attendances[a].price) === false) {
             vm.gambiPrice[a] = parseFloat(
                attendances[a].price
              ).toFixed(2).replace(".", ",");
          }
          vm.specialtiesAdd[a].initial = attendances[a].initial;
          vm.specialtiesAdd[a].end = attendances[a].end;
          vm.specialtiesAdd[a].notSchedule = attendances[a].ignoreMatch;
          vm.weekDaysSelected[a] = attendances[a].days;
        }
      }
    },
    ybtn(index){
      const vm = this;
      vm.specialtyGambiVideo[index] = vm.specialtyGambiPresencial[index]
      vm.specialtyGambiPresencial[index] = !vm.specialtyGambiPresencial[index]
      if(vm.specialtyGambiVideo[index] === undefined){
        vm.specialtyGambiVideo[index] = false
      }
      vm.updateLayout = false;
      vm.updateLayout = true;      
    },
    nbtn(index){
      const vm = this;
      vm.specialtyGambiPresencial[index] = vm.specialtyGambiVideo[index]
      vm.specialtyGambiVideo[index] = !vm.specialtyGambiVideo[index]
      if(vm.specialtyGambiPresencial[index] === undefined){
        vm.specialtyGambiPresencial[index] = false
      }
      vm.updateLayout = false;
      vm.updateLayout = true;
    },
    
  }
};
</script>
<style lang="scss" src="./Clinic.scss">
</style>